import { takeQuery, createApiHandler } from '../../agent';
import types from './types';

const Language = {
	getDefaultLanguage: params => {
		const {axiosConfig} = params;
		//TODO: This if is a small hack for using a custom api and not recreate it.
		// Must be changed when keycloak is moved to the frontent in all apps
		if(axiosConfig?.get){
			return axiosConfig.get('/defaultLanguage')
		} else {
			const config = params && params.axiosConfig;
			return createApiHandler(config, null, null).get(`/defaultLanguage`);
		}
	}
};

export default [
	takeQuery(types.GET_DEFAULT_LANGUAGE, Language.getDefaultLanguage)
];
